require('intersection-observer');

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

const targets = document.querySelectorAll(['img', 'iframe', 'source']);

const lazyLoad = target => {
    const io = new IntersectionObserver((entries, observer) => {
        function attributeNullOrEmpty(entry, attribute) {
            let attributeValue = entry.target.getAttribute(attribute);
            return attributeValue === null || attributeValue === '';
        }

        // Only include entries that have data-lazy and that don't have a src or srcset
        entries.filter(entry => !attributeNullOrEmpty(entry, 'data-lazy'))
               .filter(entry => attributeNullOrEmpty(entry, 'src'))
               .filter(entry => attributeNullOrEmpty(entry, 'srcset'))
               .forEach(entry => {
                    const element = entry.target;
                    if ((entry.isIntersecting)) {
                        const src = element.getAttribute('data-lazy');
                        if (element.tagName == 'SOURCE') {
                            element.setAttribute('srcset', src);
                        } else {
                            element.setAttribute('src', src);
                        }
                        observer.disconnect();
                    }
        });
    });
    io.observe(target)
};

targets.forEach(lazyLoad);
